import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';
import { EnquiryService } from 'src/app/services/enquiry-service';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-help',
  standalone: true,
  imports: [BreadcrumbComponent, FormsModule, CommonModule, MatIconModule],
  templateUrl: './help.component.html',
  styleUrl: './help.component.scss'
})
export class HelpComponent {
  enquiryForm = {
    name: '',
    email: '',
    phone: '',
    message: ''
  };

  submitting = false;

  constructor(
    private enquiryService: EnquiryService,
    private snackBar: MatSnackBar
  ) {}

  async submitEnquiry() {
    this.submitting = true;
    try {
      await this.enquiryService.submitEnquiry(this.enquiryForm);
      this.snackBar.open('✅ Enquiry submitted successfully!', '', { duration: 2000 });
      this.enquiryForm = { name: '', email: '', phone: '', message: '' };
    } catch (error) {
      this.snackBar.open('❌ Failed to submit enquiry', '', { duration: 2000 });
    } finally {
      this.submitting = false;
    }
  }
}
